import "./LeftBanner.scss";

export const LeftBanner = () => {
  const base_url = window.location.origin;
  return (
    <a href={base_url + "/invite"} target="_blank" rel="noopener" style={{height:"fit-content"}}>
      <img src="/assets/banners/BannerIZQ_APP_2.png" alt="Store Invite" id="left_banner" className="center-block"/>
    </a>
  )
}